import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slide from './slide';
import { NextArrow, PreviousArrow, BasicCarousel } from 'components';
import { breakPoints, BPOINT } from 'constants/breakpoints';
import { connect } from 'react-redux';
import './image-nav.scss';

class ImageNavCarousel extends Component {
    state = {};
    static propTypes = {
        pageName: PropTypes.string,
        items: PropTypes.arrayOf(
            PropTypes.shape({
                text: PropTypes.string,
                url: PropTypes.string,
                image: PropTypes.string
            })
        ),
        itm: PropTypes.shape({
            source: PropTypes.string,
            medium: PropTypes.string
        })
    };
    render() {
        const { items, pageName, itm } = this.props;
        const renderItems = () =>
            items.map((item, i) => <Slide item={item} key={i} itm={itm} />);

        const settings = {
            nextArrow: (
                <NextArrow
                    pageType={pageName}
                    className="d-flex v-100 align-items-center"
                />
            ),
            prevArrow: (
                <PreviousArrow
                    pageType={pageName}
                    className="d-flex v-100 align-items-center"
                />
            ),
            dots: true,
            infinite: true,
            speed: 500,
            lazyLoad: true,
            slidesToShow: 8,
            slidesToScroll: 4,
            responsive: [
                {
                    breakpoint: breakPoints[BPOINT.XLarge].min,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: breakPoints[BPOINT.medium].min,
                    settings: 'unslick'
                }
            ]
        };

        return (
            <div
                className="container"
                style={{ maxWidth: 'calc(100% - 4rem)' }}>
                <BasicCarousel
                    className="image-nav--carousel"
                    settings={settings}
                    render={() => renderItems()}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    pageName: state.initData.pageName,
    ...ownProps
});

export default connect(mapStateToProps)(ImageNavCarousel);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/carousels/image-nav/image-nav.jsx